import React from 'react';
import { Box } from 'bloomer';
import { Link } from '@reach/router';
import { Title } from 'bloomer/lib/elements/Title';
import { Container } from 'bloomer/lib/layout/Container';

const FourOhfourPage = (props: { path: string }) => (
  <Container>
    <Box hasTextAlign="centered">
      <Title>404: Page Not Found</Title>
      <p>
        Click <Link to="/">here</Link> to return home.
      </p>
    </Box>
  </Container>
);

export default FourOhfourPage;
